import React from "react";
import { Link } from "gatsby";
import Loadable from "@loadable/component";
import { fontsName } from "../assets/fonts/fontsName";
import { request, gql } from "graphql-request";
import images from "../assets/images/sch-slide1.png";
import { REQUEST_URL } from "./RequestUrl";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  items: 1,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
};

const SLIDER_QUERY = gql`
  {
    getAllWebsiteSlider {
      _id
      pictureLink
    }
  }
`;

const MainBanner = () => {
  // Popup Video

  const [display, setDisplay] = React.useState(false);
  const [sliderImages, setSliderImages] = React.useState([]);

  React.useEffect(() => {
    request(REQUEST_URL, SLIDER_QUERY).then((data) => {
      setSliderImages(data.getAllWebsiteSlider);
    });
  }, []);

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  return (
    <React.Fragment>
      {/* If you want to change the video need to update videoID */}

      {display ? (
        <OwlCarousel
          className="home-slides owl-carousel owl-theme"
          {...options}
        >
          {sliderImages && sliderImages.length > 0
            ? sliderImages.map((image, index) => (
                <div
                  key={index}
                  className="main-banner-item"
                  // id="img-1"
                  style={{ backgroundImage: `url(${image.pictureLink})` }}
                >
                  <div className="d-table">
                    <div className="d-table-cell">
                      <div className="container"></div>
                    </div>
                  </div>
                </div>
              ))
            : ""}

          {/* <div className="main-banner-item item-bg1" id="img-1">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container"></div>
              </div>
            </div>
          </div>

          <div className="main-banner-item item-bg2">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container"></div>
              </div>
            </div>
          </div> */}
        </OwlCarousel>
      ) : (
        ""
      )}

      {/* <div className="btn-type">
				<Link  to="#"><span style={{fontFamily:fontsName.Yekan}}>الکترونیک</span> </Link>
				<Link to="/software/raysa"><span style={{fontFamily:fontsName.Yekan}}>نرم افزار</span></Link>
			</div>							 */}
    </React.Fragment>
  );
};

export default MainBanner;
